import { MANUFACTURING_ORDER_CONSTRAINTS } from './constraints.js';
export const SCHEDULED_WINDOW_MESSAGE = `${MANUFACTURING_ORDER_CONSTRAINTS.scheduledEnd.label} cannot be before ${MANUFACTURING_ORDER_CONSTRAINTS.dateScheduledToStart.label.toLowerCase()}.`;
/**
 * Whether a scheduled window runs forwards.
 *
 * Equal ends are legal: a work order started and finished inside one day is the common case on
 * the floor.
 *
 * Either end missing is *not* this rule's failure — the required-field checks own that, and
 * reporting both against one field would put two messages on one input.
 */
export function isScheduledWindowOrdered(start, end) {
    if (start === null || start === undefined || start === '')
        return true;
    if (end === null || end === undefined || end === '')
        return true;
    const from = new Date(start).getTime();
    const to = new Date(end).getTime();
    if (Number.isNaN(from) || Number.isNaN(to))
        return true;
    return to >= from;
}
//# sourceMappingURL=scheduled-window.js.map